var __jsx = React.createElement;
import React from 'react';
import { colorPalette } from '../../../styles/styleGuide';
var defaultProps = {
  color: colorPalette.orange
};
var HouseFloor0 = function HouseFloor0(_ref) {
  var color = _ref.color;
  return __jsx("svg", {
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    "data-id": "icons_HouseFloor0_svg"
  }, __jsx("title", {
    "data-id": "icons_HouseFloor0_title"
  }, "Begane Grond Verdieping"), __jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-id": "icons_HouseFloor0_g"
  }, __jsx("g", {
    transform: "translate(-78.000000, -767.000000)",
    fill: color,
    "data-id": "icons_HouseFloor0_g_3"
  }, __jsx("g", {
    transform: "translate(40.000000, 761.000000)",
    "data-id": "icons_HouseFloor0_g_4"
  }, __jsx("g", {
    transform: "translate(38.000000, 6.000000)",
    "data-id": "icons_HouseFloor0_g_5"
  }, __jsx("g", {
    transform: "translate(4.375000, 8.437500)",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor0_g_6"
  }, __jsx("path", {
    d: "M5.125,5.5 C5.125,6.21875 4.90625,6.78125 4.40625,7.09375 C3.9375,7.4375 3.1875,7.5625 2.125,7.5625 L0,7.5625 L0,0.5 C0.75,0.4375 1.40625,0.375 1.96875,0.375 C2.9375,0.375 3.65625,0.53125 4.09375,0.8125 C4.53125,1.09375 4.75,1.5625 4.75,2.1875 C4.75,2.4375 4.71875,2.65625 4.59375,2.90625 C4.53125,3.125 4.375,3.3125 4.21875,3.46875 C4.0625,3.625 3.875,3.71875 3.65625,3.8125 C4.625,4.09375 5.125,4.65625 5.125,5.5 Z M2.0625,6.53125 C2.625,6.53125 3.03125,6.46875 3.25,6.28125 C3.46875,6.09375 3.59375,5.84375 3.59375,5.46875 C3.59375,4.75 3.15625,4.4375 2.21875,4.4375 L1.4375,4.4375 L1.4375,6.5625 L2.0625,6.5625 L2.0625,6.53125 Z M3.28125,2.28125 C3.28125,1.96875 3.15625,1.75 2.96875,1.625 C2.78125,1.46875 2.46875,1.40625 2.03125,1.40625 C1.875,1.40625 1.78125,1.40625 1.6875,1.40625 C1.625,1.40625 1.53125,1.40625 1.46875,1.4375 L1.46875,3.40625 L2.1875,3.40625 C2.53125,3.40625 2.78125,3.28125 3,3.09375 C3.21875,2.9375 3.28125,2.625 3.28125,2.28125 Z M9.03125,4.78125 L9.03125,3.6875 L11.625,3.6875 L11.625,6.875 C11.46875,7.03125 11.28125,7.1875 11.03125,7.3125 C10.78125,7.46875 10.46875,7.53125 10.125,7.625 C9.75,7.6875 9.40625,7.75 9.03125,7.75 C8.3125,7.75 7.6875,7.59375 7.21875,7.3125 C6.75,7 6.375,6.5625 6.09375,6 C5.84375,5.4375 5.71875,4.78125 5.71875,4 C5.71875,3.21875 5.875,2.5625 6.125,2 C6.375,1.4375 6.78125,1.03125 7.3125,0.71875 C7.84375,0.40625 8.4375,0.28125 9.1875,0.28125 C9.5625,0.28125 9.9375,0.34375 10.3125,0.46875 C10.65625,0.59375 10.9375,0.71875 11.125,0.90625 C11.34375,1.09375 11.4375,1.25 11.4375,1.4375 C11.4375,1.5625 11.40625,1.6875 11.28125,1.8125 C11.15625,1.96875 11.0625,2.125 10.90625,2.21875 C10.59375,1.96875 10.34375,1.78125 10.09375,1.65625 C9.84375,1.53125 9.53125,1.5 9.1875,1.5 C8.5625,1.5 8.03125,1.71875 7.6875,2.125 C7.34375,2.5625 7.15625,3.15625 7.15625,4 C7.15625,4.84375 7.34375,5.5 7.6875,5.9375 C8.03125,6.375 8.53125,6.59375 9.1875,6.59375 C9.5,6.59375 9.75,6.5625 9.96875,6.4375 C10.03125,6.40625 10.15625,6.375 10.21875,6.28125 L10.21875,4.75 L9.03125,4.75 L9.03125,4.78125 Z",
    "data-id": "icons_HouseFloor0_path"
  })), __jsx("path", {
    d: "M10.03125,1.84375 L1.59375,6.875 L1.625,18.40625 L17.5,18.4375 C18.03125,18.4375 18.4375,18.03125 18.4375,17.5 L18.4375,6.90625 L10.03125,1.84375 Z M10.03125,0.03125 L20.03125,6.03125 L20,18.125 C20,19.15625 19.15625,20 18.125,20 L0.03125,20 L0.03125,6 L10.03125,0.03125 Z",
    fillRule: "nonzero",
    "data-id": "icons_HouseFloor0_path_8"
  }))))));
};
HouseFloor0.defaultProps = defaultProps;
export default HouseFloor0;